//Custom components
import StatCard from '../../../UI/Card/StatCard';

const TotalGrantees = ({ count }: { count: number }) => {
  return <StatCard title='Total Grantees' stat={count} />;
};

export default TotalGrantees;
